module.exports = __webpack_public_path__ + "static/media/jira.801235b3.png";